import type { LibraryItem, Region, Track } from './contracts';
export function trackFilterOf(item: {
  track: Track;
  region: Region | null;
  operator_slug: string | null;
}): 'Foundation' | 'Antarctica' | 'Arctic' | 'Operator' {
  if (item.operator_slug) return 'Operator';
  if (item.region === 'antarctica') return 'Antarctica';
  if (item.region === 'arctic') return 'Arctic';
  return 'Foundation';
}

export function learningRole(item: Pick<LibraryItem, 'kind' | 'track'>): string {
  if (item.kind === 'module')
    return item.track === 'regional' ? 'Specialist module' : 'Required for Foundation';
  return item.kind === 'certification' ? 'Credential reference' : 'Reference · not required for Foundation';
}

const WORDS_PER_MINUTE = 150;
const RANGE = /(\d+)\s*(?:–|-|to)\s*(\d+)/;
const NUMBER = /(\d+)/;

/** Use the upper duration bound so late planned chapters remain reachable; otherwise estimate from words. */
export function readingSeconds(label: string, words: number | null): number {
  const range = RANGE.exec(label);
  if (range) {
    const a = Number(range[1]);
    const b = Number(range[2]);
    if (a > 0 && b > 0) return Math.max(a, b) * 60;
  }
  const single = NUMBER.exec(label);
  if (single) {
    const a = Number(single[1]);
    if (a > 0) return a * 60;
  }
  if (words && words > 0) return Math.round((words / WORDS_PER_MINUTE) * 60);
  return 60;
}

export function runtimeReadout(label: string, words: number | null): string {
  const range = RANGE.exec(label);
  if (range) return `${range[1]}–${range[2]} min`;
  const single = NUMBER.exec(label);
  if (single) return `${single[1]} min`;
  if (words && words > 0) return `${Math.max(1, Math.round(words / WORDS_PER_MINUTE))} min`;
  return label;
}
